module.exports = __webpack_public_path__ + "img/ResultsTypes_Other_Result_Types.aad3c657.jpg";